module.exports = __webpack_public_path__ + "media/roomBgm.2279c670.mp3";